export enum Color {
  DarkBlack = '#313542',
  LightBlack = '#555f61',
  DarkGrey = '#b6bfcf',
  Grey = '#f6f6f6',
  LightGrey = '#d0d9e0',
  DarkWhite = '#fbfbfb',
  LightWhite = '#ffffff',
  DarkBlue = '#0f2b5b',
  LightBlue = '#008bff',
  DarkGreen = '#008b94',
  DarkGreen900 = '#0491a9',
  Green = '#1bc16e',
  LightGreen = '#00ca9d',
  DarkOrange = '#ff9b00',
  LightOrange = '#feb568',
  DarkPurple = '#5c4f89',
  LightPurple = '#bc9bc3',
  DarkRed = '#dd3521',
  LightRed = '#ff647c',
}
